import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.9998 28.5494L11.2912 34.839C10.6367 35.3116 9.76097 34.6669 10.0178 33.9016L13.4542 23.6617L4.70043 17.3331C4.04776 16.8612 4.38154 15.8298 5.18691 15.8298H15.8838L19.2099 5.57418C19.4582 4.80861 20.5413 4.80861 20.7896 5.57418L24.1158 15.8298H34.8126C35.618 15.8298 35.9518 16.8612 35.2991 17.3331L26.5454 23.6617L29.9817 33.9016C30.2386 34.6669 29.3628 35.3116 28.7084 34.839L19.9998 28.5494Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }